// extracted by mini-css-extract-plugin
module.exports = {"rateType":"ratingCard_rateType__33RQv","rating":"ratingCard_rating__13JST","count":"ratingCard_count__1FSZZ"};